import React from 'react'
import EEvaluation from 'src/modules/EEvaluation'

const EEvaluationPage = () => {
  return <EEvaluation />
}
export default EEvaluationPage
